import getHelper from '../../../../services/getHelper';
import type { QuizInformation } from '../../types/QuizInformation';

export default getHelper<QuizInformation>('/quiz/:id', {
  reset: getHelper<QuizInformation>('/reset'),
});
